import { Injectable } from '@angular/core';
import { AutoAssignmentApi } from '../api/auto-assignment.api';
import { EdlAutomationRuleDTO } from '../model/edl-automation/edl-automation-rule-dto.model';

@Injectable({
    providedIn: 'root'
})
export class AutoAssignmentService {
    constructor(private autoAssignmentApi: AutoAssignmentApi) { }

    getAllRules = () => this.autoAssignmentApi.getAllAutoAssignmentRules();

    getPermissions = () => this.autoAssignmentApi.getPermissions();

    addAutoAssignmentRule = () => this.autoAssignmentApi.addAutoAssignmentRule();

    addDefaultAutoAssignmentRules = () => this.autoAssignmentApi.addDefaultAutoAssignmentRules();

    updateAutoAssignmentRule(autoAssignmentRule: EdlAutomationRuleDTO) {
       return this.autoAssignmentApi.updateAutoAssignmentRule(autoAssignmentRule)
    }

}